import PrincipalWelcomeChecklist from "../components/PrincipalFlow/PrincipalWelcomeChecklist";
import ProducerWelcomeChecklist from "../components/ProducerFlow/ProducerWelcomeChecklist";
import CreateYourProfileChecklist from "../components/CreateYourProfile/CreateYourProfileChecklist";
import CreateYourProfile from "../components/CreateYourProfile/CreateYourProfile";
import CreateYourProfileKickout from "../components/CreateYourProfile/CreateYourProfileKickout";
import PrincipalPersonalInformation from "../components/PrincipalFlow/PersonalInformation/PrincipalPersonalInformation";
import PrincipalBackgroundInformation from "../components/PrincipalFlow/PrincipalBackgroundInformation";
import PrincipalRequestAuthorizedRep from "../components/PrincipalFlow/PrincipalRequestAuthorizedRep";
import PrincipalAgencyOfficeInformation from "../components/PrincipalFlow/AgencyOfficeInformation/PrincipalAgencyOfficeInformation";
import PrincipalAgencyEmployeeInformation from "../components/PrincipalFlow/AgencyEmployeeInformation/PrincipalAgencyEmployeeInformation";
import PrincipalAgencyFinancialInformation from "../components/PrincipalFlow/PrincipalAgencyFinancialInformation";
import PrincipalErrorsAndOmissions from "../components/PrincipalFlow/PrincipalErrorsAndOmissions";
import PrincipalBankingInformation from "../components/PrincipalFlow/BankingInformation/PrincipalBankingInformation";
import PrincipalW9TaxForm from "../components/PrincipalFlow/W9TaxForm/PrincipalW9TaxForm";
import PrincipalReviewAndSign from "../components/PrincipalFlow/PrincipalReviewAndSign";
import ProducerReviewAndSign from "../components/ProducerFlow/ProducerReviewAndSign";
import ProducerSubmitApplication from "../components/ProducerFlow/ProducerSubmitApplication";
import ProducerBackgroundInformation from "../components/ProducerFlow/ProducerBackgroundInformation";
import ProducerPersonalInformation from "../components/ProducerFlow/PersonalInformation/ProducerPersonalInformation";
import { GeaoPaths } from "./GeaoPaths";
import PrincipalApplicationSubmitted from "../components/PrincipalFlow/ApplicationSubmitted/PrincipalApplicationSubmitted";
import ProducerApplicationSubmitted from "../components/ProducerFlow/ProducerApplicationSubmitted";
import PrincipalAgencyAdditionalInformation from "../components/PrincipalFlow/AgencyAdditionalInformation/PrincipalAgencyAdditionalInformation";
import ProducerKickout from "../components/ProducerFlow/ProducerKickout";
import PrincipalKickout from "../components/PrincipalFlow/PrincipalKickout";
import ApplicationStatus from "../components/Recall/ApplicationStatus";
import RecallVerification from "../components/Recall/RecallVerification";
import RecallSendCode from "../components/Recall/RecallSendCode";
import PrincipalApplicationInProgressOverview from "../components/ApplicationStatus/PrincipalApplicationInProgress";
import PrincipalBackgroundCheckInProgressOverview from "../components/ApplicationStatus/PrincipalBackgroundCheckInProgress";
import PrincipalApplicationCompleteOverview from "../components/ApplicationStatus/PrincipalApplicationComplete";
import ProducerBackgroundCheckInProgress from "../components/ApplicationStatus/ProducerBackgroundCheckInProgress";
import ProducerApplicationComplete from "../components/ApplicationStatus/ProducerApplicationComplete";
import ProducerApplicationInProgressOverview from "../components/ApplicationStatus/ProducerApplicationInProgress";
import BackgroundCheckDenial from "../components/ApplicationStatus/BackgroundCheckDenial";
import TechnicalDifficulties from "../components/shared/Kickout/TechnicalDifficulties";
import SessionExpired from "../components/shared/Kickout/SessionExpired";
import OnboardingPaused from "../components/shared/Kickout/OnboardingPaused";

export const GeaoRoutes = [
    // Create your profile
    {
        authorize: _ => true,
        path: GeaoPaths.CreateYourProfileChecklist,
        element: <CreateYourProfileChecklist />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.CreateYourProfile,
        element: <CreateYourProfile />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.CreateYourProfileKickout,
        element: <CreateYourProfileKickout />
    },

    // Principal flow
    {
        authorize: _ => true,
        path: GeaoPaths.PrincipalWelcomeChecklist,
        element: <PrincipalWelcomeChecklist />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.PrincipalPersonalInformation,
        element: <PrincipalPersonalInformation />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.PrincipalBackgroundInformation,
        element: <PrincipalBackgroundInformation />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.PrincipalRequestAuthorizedRep,
        element: <PrincipalRequestAuthorizedRep />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.PrincipalAgencyOfficeInformation,
        element: <PrincipalAgencyOfficeInformation />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.PrincipalAgencyEmployeeInformation,
        element: <PrincipalAgencyEmployeeInformation />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.PrincipalAgencyFinancialInformation,
        element: <PrincipalAgencyFinancialInformation />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.PrincipalAgencyAdditionalInformation,
        element: <PrincipalAgencyAdditionalInformation />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.PrincipalErrorsAndOmissions,
        element: <PrincipalErrorsAndOmissions />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.PrincipalBankingInformation,
        element: <PrincipalBankingInformation />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.PrincipalW9TaxForm,
        element: <PrincipalW9TaxForm />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.PrincipalReviewAndSign,
        element: <PrincipalReviewAndSign />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.PrincipalApplicationSubmitted,
        element: <PrincipalApplicationSubmitted />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.PrincipalKickout,
        element: <PrincipalKickout />
    },

    // Producer flow
    {
        authorize: _ => true,
        path: GeaoPaths.ProducerWelcomeChecklist,
        element: <ProducerWelcomeChecklist />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.ProducerBackgroundInformation,
        element: <ProducerBackgroundInformation />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.ProducerPersonalInformation,
        element: <ProducerPersonalInformation />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.ProducerSubmitApplication,
        element: <ProducerSubmitApplication />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.ProducerReviewAndSign,
        element: <ProducerReviewAndSign />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.ProducerApplicationSubmitted,
        element: <ProducerApplicationSubmitted />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.ProducerKickout,
        element: <ProducerKickout />
    },

    // Recall flow
    {
        authorize: _ => true,
        path: GeaoPaths.ApplicationStatus,
        element: <ApplicationStatus />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.RecallVerification,
        element: <RecallVerification />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.RecallSendCode,
        element: <RecallSendCode />
    },

    // Application Status
    {
        authorize: _ => true,
        path: GeaoPaths.PrincipalBackgroundCheckInProgress,
        element: <PrincipalBackgroundCheckInProgressOverview />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.PrincipalApplicationInProgress,
        element: <PrincipalApplicationInProgressOverview />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.PrincipalApplicationComplete,
        element: <PrincipalApplicationCompleteOverview />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.ProducerApplicationInProgress,
        element: <ProducerApplicationInProgressOverview />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.ProducerBackgroundCheckInProgress,
        element: <ProducerBackgroundCheckInProgress />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.ProducerApplicationComplete,
        element: <ProducerApplicationComplete />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.BackgroundCheckDenial,
        element: <BackgroundCheckDenial />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.TechnicalDifficulties,
        element: <TechnicalDifficulties />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.SessionExpired,
        element: <SessionExpired />
    },
    {
        authorize: _ => true,
        path: GeaoPaths.OnboardingPaused,
        element: <OnboardingPaused />
    },
];